import { AfterViewInit, ChangeDetectorRef, Component, effect, EventEmitter, Inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AttachmentViewerComponent } from '@app/lib/components/attachment-viewer/attachment-viewer.component';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { TAny } from '@app/lib/models/common.type';
import { IAttachmentDialogData } from '@app/lib/models/dialog-data.model';
import { IResponse } from '@app/lib/models/response.model';
import { DialogService } from '@app/lib/services/dialog.service';
import { catchError, debounceTime, EMPTY, filter, finalize, switchMap, take } from 'rxjs';
import { ETaskScreenName, IAssignedTask, IAssignedTaskEvent } from '../models/assigned-task.model';
import { ICaseItem, ICaseSearchRequestBody, ISearchRequestParams } from '../models/case-assignment.model';
import { ECasePartyRoleType } from '../models/constant';
import { IHPAttachment, IHpCaseDocumentType, } from '../models/hearing-process.model';
import { AssignedTaskService } from '../services/assigned-task.service';
import { DocumentReceptionService } from '../services/document-reception.service';
import { AdditionalSupremeCourtCaseData, CaseDataPayload, DocParty, DocPartyData, DocType, IDRattachementParams, IDRAttachment, IDRCaseCommentsDTO, IDRCaseDocument, IDRCaseSearchRequestBody, IDRlistOfFiles, IDRlistOfFilesParams, IDRmotionCaseNumber, IDRmotionCaseNumberParams, IDRPartiesDTO, IDRPartyRepresentationDTO, Label, PrintRecieptRequest, WitnessData } from '../models/document-reception.model';
import { LoaderComponent } from "../../lib/components/loader/loader.component";
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommentsDialogComponent } from './comments-dialog/comments-dialog.component';
import { CustomCaseTypeBasedDocType, DocumentTypeModel, Party } from '../models/document-details.model';
import { AddPartyDialogComponent } from './add-party-dialog/add-party-dialog.component';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { DocumentDetailEditComponent } from './document-detail-edit/document-detail-edit.component';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { ILoginData } from '@app/lib/models/login.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogModule, MatDialogConfig } from '@angular/material/dialog';
import { AppealRecordDTO } from '@app/dashboard/models/document-details.model';
import { AlphaNumSlashDirective } from '@app/shared/alpha-num-slash.directive';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { ECaseCategory, ECourtId } from '@app/dashboard/models/constant';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconRegistry } from '@angular/material/icon'; // Import this
import { DomSanitizer } from '@angular/platform-browser'; // Import this
import { DashboardComponent } from '../dashboard.component';
import { DocumentDetailsService } from '@app/dashboard/services/document-details.service';
import { APP_STRING } from '@app/shared/shared.constants';
import { MatDialogRef } from '@angular/material/dialog';

import { CaseNumberSearchComponent } from '../widget/case-number-search/case-number-search.component';


@Component({
  selector: 'app-documents-reception',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    BreadcrumbComponent,
    MatDatepickerModule,
    ScrollingModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AlphaNumSlashDirective,
    MatTooltipModule,
    MatTooltip,
    NgxMatSelectSearchModule,
    CaseNumberSearchComponent
  ],
  templateUrl: './document-reception.component.html',
  styleUrl: './document-reception.component.scss',
  providers: [DatePipe, MatDialogConfig,]
})
export class DocumentReceptionComponent implements OnInit, AfterViewInit {


  today: Date = new Date();
  courtData: ILoginData | null = null;
  displayedColumns: string[] = [];
  columnDefinitions: any[] = [];
  filteredDocumentTypes: DocType[] = [];
  selectedDocumentType: DocType | null = null;
  documentSearch: string = '';
  dateReceived: Date | null = null;
  isUploading: boolean = false;
  courtIdData: number | null = null;
  isSupremeCourtFlg: boolean = false;
  isCOAFlg: boolean = false;
  assignButtonName: string = 'Add';
  isDirectAssign: boolean = false;
  documentTypes: CustomCaseTypeBasedDocType | null = null;
  caseStages: DocumentTypeModel | null = null
  strings = APP_STRING;
  userComments: string = '';


  ngOnInit(): void {
    this.loadCourtData();
    this.setTableHeaders();
    this.getDocType()
    this.dateReceived = this.today;
    this.onDateChange({ value: this.today });
    this.route.queryParams.subscribe(params => {
      const caseNumber = params['caseNumber'];

      if (!caseNumber) {
        console.warn('No case number provided in query params.');
        return;
      } else {
        this.searchFormGrp.reset({
          caseNumber: caseNumber
        });
        this.searchHandler(caseNumber, true);
      }

      //console.log('Received case number:', caseNumber);


    });

    this.docTypeFilterCtrl.valueChanges.subscribe((search: string) => {
      this.filterDocumentTypes({ target: { value: search } } as any);
    });

  }

  selectedTab = 'parties';
  selectedTab2 = 'partiesRepresented';
  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
    { label: 'Documents' },
    { label: 'Documents Reception' },
  ]);

  public partyRoleType = ECasePartyRoleType;

  public searchFormGrp: FormGroup = new FormGroup({
    caseNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    documentType: new FormControl('')
  });

  public formGrp: FormGroup = new FormGroup({
    docTypeId: new FormControl('', [Validators.required]),
    casePhaseId: new FormControl('', [Validators.required]),
    motionDocumentStatus: new FormControl(''),
    comments: new FormControl(''),
  });

  public docFormGrp: FormGroup = new FormGroup({
    docUploadDateReceived: new FormControl(this.today, [Validators.required]),
    file: new FormControl('', [Validators.required]),
    selectedFile: new FormControl('', [Validators.required])
  });

  public caseListLoader: WritableSignal<boolean> = signal(false);
  public caseList: WritableSignal<ICaseItem[]> = signal([]);
  public docTypeList: WritableSignal<DocType[]> = signal([]);
  public MotioncaseList: WritableSignal<IDRmotionCaseNumber[]> = signal([]);
  public task: WritableSignal<IAssignedTask | null> = signal(null);
  public taskDetails: WritableSignal<string | null> = signal(null);
  public caseData: WritableSignal<IDRCaseDocument[]> = signal([]);
  public attachmentsData: WritableSignal<IDRAttachment[]> = signal([]);
  public listOfFiles: WritableSignal<IDRlistOfFiles[]> = signal([]);
  public commentsData: WritableSignal<IDRCaseCommentsDTO[]> = signal([]);
  public groupPartiesData: WritableSignal<IDRPartiesDTO[]> = signal([]);
  public listofPartiesData: WritableSignal<Party[]> = signal([]);
  public counselPartiesData: WritableSignal<IDRPartyRepresentationDTO[]> = signal([]);
  public selectedRepPartiesData: WritableSignal<Party[]> = signal([]);

  public partyDetails: WritableSignal<DocParty[]> = signal([]);
  public witnessData: WritableSignal<WitnessData[]> = signal([]);
  public selectedWitnessData: WritableSignal<Party[]> = signal([]);
  public label_enum = Label;
  public caseDataSource: MatTableDataSource<IDRCaseDocument> = new MatTableDataSource();
  public savePayload: WritableSignal<CaseDataPayload[]> = signal([]);
  public docTypeFilterCtrl: FormControl = new FormControl('');

  selectedData: any[] = [];
  selectedparties: DocParty | null = null;
  selectedDoc: IDRAttachment | any = null;
  selectedPartyrep: IDRPartyRepresentationDTO | any = null;
  areAllSelected: boolean = false;
  selectedCaseNumber: string | null = null;
  filteredFiles: any[] = [];
  fileUrl: string = '';
  formattedDate: String | null = null;
  selectedFile: File | null = null;
  isAddMode: boolean = false;
  isRepEdit: boolean = false;
  loading: boolean = false;
  isAddSearchHandlerDD: boolean = false;
  myNewRes: any = '';
  additionalSupremeCourtData: AdditionalSupremeCourtCaseData = createDefaultAdditionalSupremeCourtCaseData();
  partyRoles: any[] = [];
  userType: string = "";
  public isLoadingAttachments: boolean = false;
  public attachmentsRefreshed: EventEmitter<void> = new EventEmitter<void>();
  isDashboard: boolean = false;

  constructor(
    private service: DocumentReceptionService,
    private assignTaskService: AssignedTaskService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,
    private dashboard: DashboardComponent,
    private dialogService: DialogService,
    private matIconRegistry: MatIconRegistry, private sanitizer: DomSanitizer,
    private documentDetailsService: DocumentDetailsService
  ) {
    this.matIconRegistry.addSvgIcon(
      'clipboard_add',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/backlog_add_icon.svg')
    );
    this.searchbyCaseNoChange();
    this.assignTaskService.assignTask$
      .pipe(
        takeUntilDestroyed(),
        filter(event => event.name === ETaskScreenName.DOCUMENTRECEPTION)
      )
      .subscribe({
        next: (event: IAssignedTaskEvent) => {
          this.task.set(event.task);
          this.taskDetails.set(this.task()?.taskDetails ?? null)
          this.searchFormGrp.reset({
            caseNumber: event.task.courtCaseNumber
          });
          if (event.task.typeName.trim().toUpperCase() === this.strings.CASE_ASSIGNMENT_TASK) {
            this.isDirectAssign = true;
            this.assignButtonName = this.strings.CASE_ASSIGNMENT_BUTTON; // Corrected syntax (added semicolon)
          } else if (event.task.typeName.trim().toUpperCase() === this.strings.VALIDATE_DOCUMENTS_TASK) {
            this.isDirectAssign = true;
            this.assignButtonName = this.strings.VALIDATE_DOCUMENT_BUTTON; // FIXED: Changed 'Validated' to 'Validate' for logic matching
          }
          else {
            this.isDirectAssign = false;
            this.assignButtonName = 'Add'
          }
          this.searchHandler(event.task.courtCaseNumber);
        }
      });
    effect(() => {
      this.caseDataSource.data = this.caseData();
    });

  }
  clearQueryParams() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { caseNumber: null }, // Removes just 'caseNumber'
      queryParamsHandling: 'merge',     // Preserves other query params if they exist
      replaceUrl: true                  // Replaces current history state so 'back' button behaves nicely
    });
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;
      this.courtIdData = userData2.courtId;
      if (this.courtIdData && this.courtIdData === ECourtId.SC_ID) {

        this.isSupremeCourtFlg = true;
      } else if (this.courtIdData && this.courtIdData === ECourtId.COA_ID) {
        this.isCOAFlg = true;
      }
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }

  }

  loadCourtData(): void {
    this.courtData = this.getCourtNameData();
    //console.log('Loaded Court Data:', this.courtData);
    this.userType = this.courtData?.courtId === 1 || this.courtData?.courtId === 2 ? 'admin' : 'lawyer';
  }

  public onCaseSearchOptionSelected(item: any): void {
    const caseNo = item?.caseNumber || item?.courtCaseNumber || '';
    if (caseNo) {
      this.searchFormGrp.patchValue({ caseNumber: caseNo });
    }
  }

  setTableHeaders(): void {
    this.columnDefinitions = [
      {
        column: 'select', labels: {
          admin: '', lawyer: ''
        }, show: true
      },
      { column: 'plaintiff', labels: { lawyer: 'Plaintiff(s)/Claimant(s) ', admin: 'Appellant(s)' }, show: true },
      { column: 'defendant', labels: { lawyer: 'Defendant(s)', admin: 'Respondent(s)' }, show: true },
      { column: 'caseType', labels: { lawyer: 'Case Type', admin: 'Appeal Type' }, show: true },
      { column: 'docType', labels: { lawyer: 'Document Type', admin: 'Document Type' }, show: true },
      { column: 'caseStage', labels: { lawyer: 'Case Stage', admin: 'Appeal Stage' }, show: true },
      { column: 'caseNumber', labels: { lawyer: 'Case Number', admin: 'Appeal Number' }, show: true },
      { column: 'receivedDate', labels: { lawyer: 'Received Date', admin: 'Filed Date' }, show: true },
      { column: 'docId', labels: { lawyer: 'Document ID', admin: 'Document ID' }, show: true },
    ];

    this.displayedColumns = this.columnDefinitions
      .filter(col => col.show)
      .map(col => col.column);
  }

  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit(): void {
    this.caseDataSource.sort = this.sort;

    this.caseDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'plaintiff':
          return item.partiesByPrtIdIssuedByName || '';
        case 'defendant':
          return item.partyIdChargingName || '';
        case 'caseType':
          return item.ctpShortName || '';
        case 'docType':
          return item.docTypename || '';
        case 'caseStage':
          return item.cptShortName || '';
        case 'caseNumber':
          return item.courtCaseNumber || '';
        case 'receivedDate':
          return item.dateReceived ? new Date(item.dateReceived) : new Date(0);
        case 'docId':
          return item.docId;
        default:
          return item[property as keyof IDRCaseDocument];
      }
    };
  }

  getLabelValue(key: string): string | undefined {
    return this.label_enum[key as keyof typeof Label];
  }
  onCheckboxChange(element: any, isChecked: boolean): void {
    //console.log('Selected Element:', element);
    this.selectedTab = 'parties'

    if (isChecked) {
      if (element && element.docPartiesData) {
        this.selectedData = [element];
        this.partyDetails.set(element.docPartiesData);
        //console.log('Party Details Updated:', this.partyDetails());
      } else {
        console.warn('No docPartiesData found in the selected element');
        this.partyDetails.set([]);
      }
      this.getDocData(element.docId, element.casePhaseCasId, element.courtCaseNumber);

    } else {
      //console.log('Checkbox Unchecked. Clearing partyDetails and selectedData.');
      this.selectedData = [];
      this.partyDetails.set([]);
    }
  }
  getUniqueCases() {
    const uniqueCasesMap = new Map();
    this.MotioncaseList().forEach(caseItem => {
      if (!uniqueCasesMap.has(caseItem.id)) {
        uniqueCasesMap.set(caseItem.id, caseItem);
      }
    });
    return Array.from(uniqueCasesMap.values());
  }

  onPartyCheckboxChange(element: any, isChecked: boolean): void {
    this.selectedparties = null
    this.selectedPartyrep = null
    if (isChecked) {
      this.selectedparties = element;
      //console.log('Selected Element:', element);
      this.extractWitnessData(element.partyId);
      this.getGroupParties(element.partyId);
    } else {
      this.selectedparties = null;
    }
  }
  onRepPartyCheckboxChange(element: any, isChecked: boolean): void {
    this.selectedPartyrep = null
    if (isChecked) {
      this.selectedPartyrep = element
    } else {
      this.selectedPartyrep = null;
    }
  }
  onAttachmentsCheckboxChange(element: any, isChecked: boolean): void {
    this.selectedDoc = null;
    //console.log('clicked');
    if (isChecked) {
      this.selectedDoc = element;
    } else {
      this.selectedparties = null;
    }
  }

  openFileSelector(): void {
    this.dateReceived = null;
    this.formattedDate = null;

    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;

    if (fileInput.files && fileInput.files.length > 0) {
      this.selectedFile = fileInput.files[0];
      this.fileUrl = this.selectedFile.name;
    }

    fileInput.value = '';
    this.dateReceived = this.today;
    this.onDateChange({ value: this.today });

  }

  clearFileUrl(): void {
    this.selectedFile = null;
    this.fileUrl = '';

    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  private extractDocumentNames(taskDetails: string | null): string[] {
    if (!taskDetails) return [];
    const match = taskDetails.match(/\[(.*?)\]/);
    if (!match || !match[1]) return [];

    return match[1]
      .split(',')
      .map(item => item.trim())
      // Remove version suffix (e.g., "-1.0") if present
      .map(item => item.replace(/-\d+(\.\d+)?$/, '').trim());
  }

  public getDocData(
    docId: string,
    casePhaseCasId: string,
    caseNumber: string,
  ): void {
    this.isLoadingAttachments = true;
    this.attachmentsData.set([]);

    // Extract expected file names from the taskDetails
    const targetDocNames = this.extractDocumentNames(this.caseData()[0]?.triggeredTaskDetails ?? null);

    const params: IDRattachementParams = {
      page: 1,
      start: 0,
      limit: 25,
      docId,
      casePhaseCasId,
    };

    this.service.getDocs(params).subscribe({
      next: (res: IResponse<IDRAttachment[]>) => {
        if (res && Array.isArray(res.success) && res.success.length > 0) {
          const enrichedAttachments = res.success.map((attachment: any) => {
            // Normalizes attachment name to match against parsed task file names
            const attName = (attachment.name || attachment.docName || '').trim();

            const isMatched = targetDocNames.some(targetName =>
              attName.toLowerCase().includes(targetName.toLowerCase()) ||
              targetName.toLowerCase().includes(attName.toLowerCase())
            );

            return {
              ...attachment,
              showClosetask: isMatched
            };
          });

          this.attachmentsData.set(enrichedAttachments);
        } else {
          //console.log('No attachments found or invalid response structure.');
          this.attachmentsData.set([]);
        }
      },
      error: (err) => {
        console.error('Error fetching attachment data:', err);
      },
      complete: () => {
        this.isLoadingAttachments = false;
        this.getListOfFiles(caseNumber);
        this.changeDetector.detectChanges();
      }
    });
  }


  partiesButtonFunction(selectedtabS: string): void {
    if (selectedtabS === 'attachments') {
      this.deleteAttachments()

    } else {
      this.openAddPartyDialog(selectedtabS);
    }

  }
  onPartyRoleChange(element: any, newRole: string): void {
    element.partyRoleName = newRole;
    element.partyRoleId = newRole === "Appellant" || newRole === "Plaintiff/Claimant" || newRole === "Prosecutor" ? 1 : 3
    //console.log('Updated Party Role:', element);
  }

  openAddPartyDialog(section: string): void {
    const dialogRef = this.dialog.open(AddPartyDialogComponent, {
      data: { 'section': section, 'caseId': this.caseData()[0].casePhaseCasId, isCourtStaff: false }, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.loading = true;
      if (result) {
        if (section === "partiesRepresented") {
          this.selectedRepPartiesData.set([...this.selectedRepPartiesData(), result]);
          const transformedData: IDRPartyRepresentationDTO = {
            partyId: result.partiesId,
            partyName: result.partiesName,
            partyIdFor: null,
            casePhasesCaseId: null,
            casePhasesId: null,
            docId: null,
            beginDate: null,
            endDate: null,
            transType: "I",
            partyRoleId: null,
            partyRoleName: null,
            partyFullName: result.partiesFullName || '',
            groupPartyId: result.groupPartyId || '',
            groupPartyFlag: null,
            auditMessage: result.auditMessage || '',
            isEdit: true,
          };
          this.counselPartiesData.update((currentData) => [...currentData, transformedData]);
          //console.log(this.counselPartiesData())
        }
        else if (section === "witness") {
          this.selectedWitnessData.set([...this.selectedWitnessData(), result]);
          const transformedData: WitnessData = {
            witnessId: result.partiesId,
            witnessName: result.partiesFullName,
            witnessAddr: result.addressesData,
            witnessContact: result.mobileNumber,
            transType: "I",
            auditMessage: result.auditMessage
          };
          this.witnessData.update((currentData) => [...currentData, transformedData]);

          //console.log('Selected Party:', this.selectedRepPartiesData());
        } else if (section === "parties") {
          const transformedData: DocParty = {
            partyId: result.partiesId,
            partyName: result.partiesFullName,
            partyRoleId: 0,
            partyRoleName: "",
            timeCreated: result.timeCreated,
            termination: result.termination,
            transType: "I",
            representationData: [],
            witnessData: [],
            isEdit: true
          }
          this.partyDetails.update((currentData) => [...currentData, transformedData]);
        }
      }
      this.loading = false;
    });
  }
  extractWitnessData(targetPartyId: string): void {
    this.witnessData.set([]);

    const caseDataValue = this.partyDetails?.();

    if (caseDataValue && Array.isArray(caseDataValue)) {
      caseDataValue.forEach((item) => {
        if (item.partyId === targetPartyId) {
          this.witnessData.set(item.witnessData);
        }
      });

      //console.log("Extracted Witness Data:", this.witnessData);
    } else {
      console.warn("Case data is null or not an array");
    }
  }

  onCaseNumberChange(caseId: string): void {
    this.listOfFiles.set([]);

    const params: IDRlistOfFilesParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'docId',
      direction: 'ASC',
    };
    const reqBody = { "caseNumber": caseId, "docStatus": "VALID" };

    this.service.getListOfFiles(params, reqBody).subscribe({
      next: (res: IResponse<IDRlistOfFiles[]>) => {
        //console.log('API Response:', res);

        if (res && Array.isArray(res.data) && res.data.length > 0) {
          this.listOfFiles.set(res.data);
        } else {
          //console.log('No attachments found or invalid response structure.');
        }
        //console.log('List of Files:', this.listOfFiles());
      },
      error: (err) => {
        console.error('Error fetching listOffiles data:', err);
      },

    });


  }
  openCommentsDialog() {
    this.dialog.open(CommentsDialogComponent, {
      width: '600px',
      data: this.commentsData(), disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

  }
  public getListOfFiles(caseNumber: string): void {
    this.listOfFiles.set([]);

    const params: IDRlistOfFilesParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'docId',
      direction: 'ASC',
    };
    const reqBody = { "caseNumber": caseNumber, "docStatus": "VALID" };

    this.service.getListOfFiles(params, reqBody).subscribe({
      next: (res: IResponse<IDRlistOfFiles[]>) => {
        //console.log('API Response:', res);

        if (res && Array.isArray(res.data) && res.data.length > 0) {
          this.listOfFiles.set(res.data);
        } else {
          //console.log('No attachments found or invalid response structure.');
        }
        //console.log('List of Files:', this.listOfFiles());
      },
      error: (err) => {
        console.error('Error fetching listOffiles data:', err);
      },

    });
    this.getMotionCaseNumber(caseNumber);

  }
  public getMotionCaseNumber(caseNumber: string): void {
    this.MotioncaseList.set([]);

    const params: IDRmotionCaseNumberParams = {
      caseNumber: caseNumber,
      page: 1,
      start: 0,
      limit: 25,
      property: 'id',
      direction: 'ASC',
    };


    this.service.getMotionCaseNumber(params).subscribe({
      next: (res: IResponse<IDRmotionCaseNumber[]>) => {
        //console.log('API Response:', res);

        if (res && Array.isArray(res.success) && res.success.length > 0) {
          this.MotioncaseList.set(res.success);
          this.selectedCaseNumber = res.success[0].id;
        } else {
          //console.log('No attachments found or invalid response structure.');
        }
        //console.log('Motion Case Number:', this.MotioncaseList());
      },
      error: (err) => {
        console.error('Error fetching listOffiles data:', err);
      },

    });
    this.getComments(caseNumber);


  }
  public getComments(caseNumber: string): void {
    this.commentsData.set([]);

    const params: IDRmotionCaseNumberParams = {
      caseNumber: caseNumber,
      page: 1,
      start: 0,
      limit: 25,
      property: 'caseNumber',
      direction: 'ASC',
    };


    const reqBody = { "caseNumber": caseNumber, "docStatus": "VALID" };

    this.service.getComments(params, reqBody).subscribe({
      next: (res: IResponse<IDRCaseCommentsDTO[]>) => {
        //console.log('API Response:', res);

        if (res && Array.isArray(res.data) && res.data.length > 0) {
          this.commentsData.set(res.data);
        } else {
          //console.log('No attachments found or invalid response structure.');
        }
        //console.log('List of Files:', this.commentsData());
      },
      error: (err) => {
        console.error('Error fetching listOffiles data:', err);
      },

    });


  }
  handleSpaceKey(event: Event): void {
    const target = event as KeyboardEvent;
    if (target.code === 'Space' || target.key === ' ') {
      event.stopPropagation();
    }
  }
  public deleteAttachments() {
    if (this.selectedDoc != null) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirm Action',
          message: "Do you want to Delete?"
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {

          const reqdata: TAny = {
            "docName": this.selectedDoc.docName,
            "timeCreated": this.selectedDoc.timeCreated,
            "docUploadDateReceived": this.selectedDoc.docUploadDateReceived,
            "alfrescoUrl": this.selectedDoc.alfrescoUrl,
            "no": this.selectedDoc.no,
            "transType": "",
            "docId": this.selectedData[0].docId,
            "caseId": this.selectedData[0].casePhaseCasId,
            "casePhaseId": this.selectedData[0].casePhaseId,
            "docTypeId": this.selectedData[0].docTypeId,
          }

          this.service.deleteAttachment(reqdata).subscribe({
            next: (res: IResponse<TAny> | null) => {
              //console.log(res?.message)
              this.dialogService.openDialog1({
                data: {
                  title: "Success",
                  message: res?.message,
                  icon: 'check_small',
                }, disableClose: true,
                hasBackdrop: true,
                backdropClass: 'dialog-backdrop',
              });
              this.selectedDoc = null;
            },
            error: (err) => {
              console.error('Error fetching case data:', err);
            },
            complete: () => {
              this.getDocData(this.selectedData[0].docId, this.selectedData[0].casePhaseCasId, this.selectedData[0].courtCaseNumber)
            },
          });

        } else {
          //console.log('Cancelled!');
          // Handle the cancellation
        }
      });

    } else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "Please select attachment",
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });

    }
  }
  public getGroupParties(partyid: string) {
    this.groupPartiesData.set([]);


    this.service.searchParties({ "partiesId": partyid }).subscribe({
      next: (res: IResponse<IDRPartiesDTO[]> | null) => {
        if (res?.data && res.data.length > 0) {
          this.groupPartiesData.set(res.data);
          this.getCounselParties(partyid, true)
        }
        else {
          this.getCounselParties(partyid, false)
        }
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
      },
    });

  }
  public getDocType() {
    this.docTypeList.set([]);


    this.service.getdocList().subscribe({
      next: (res: IResponse<DocType[]>) => {
        //console.log('API Response:', res);

        if (res && Array.isArray(res.success) && res.success.length > 0) {
          const sortedDocTypes = res.success.sort((a, b) => a.docTypeId - b.docTypeId);

          this.docTypeList.set(sortedDocTypes);
          this.filteredDocumentTypes = [...this.docTypeList()];
        } else {
          //console.log('No doc type found for this user.');
        }
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
      },
    });

  }
  public filterDocumentTypes(searchTerm: Event): void {
    const target = searchTerm.target as HTMLInputElement;
    if (target) {
      this.documentSearch = target.value.toLowerCase();
      this.filteredDocumentTypes = this.docTypeList().filter((doc) =>
        doc.docTypeName.toLowerCase().includes(this.documentSearch) ||
        doc.docTypeId.toString().includes(this.documentSearch)
      ).sort((a, b) => a.docTypeId - b.docTypeId);
    }
  }

  public onDocumentTypeChange(selected: DocType): void {
    this.selectedDocumentType = selected;
    //console.log('Selected Document Type:', this.selectedDocumentType);
  }

  public getCounselParties(partyid: string, group: boolean) {
    this.counselPartiesData.set([]);
    const reqBody: TAny = {
      "partyIdFor": partyid,
      "casePhasesCaseId": this.caseData()?.[0]?.casePhaseCasId,
      "groupPartyFlag": group
    }

    this.service.searchCounsels(reqBody).subscribe({
      next: (res: IResponse<IDRPartyRepresentationDTO[]> | null) => {
        if (res?.data && res.data.length > 0) {
          this.counselPartiesData.set(res.data);
        }
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
      },
    });
  }
  public sentMail() {
    const reqBody: TAny = {
      "id": this.caseData()?.[0]?.casePhaseId,
      "courtCaseNumber": this.caseData()?.[0]?.courtCaseNumber,
      "caseCategory": this.caseData()?.[0]?.caseCategory,
      "courtUnitShortName": this.caseData()?.[0]?.courtUnitShortName,
      "cutId": "0",
      "docId": this.caseData()?.[0]?.docId,
      "courtUnitId": this.caseData()?.[0]?.courtUnitId,
      "courtUnitName": this.caseData()?.[0]?.courtUnitName,
      "hearingCourtUnitId": this.caseData()?.[0]?.hearingCourtUnitId,
      "hearingCourtUnitName": this.caseData()?.[0]?.hearingCourtUnitName,
      "docTypeId": this.caseData()?.[0]?.docTypeId,
      "docTypename": this.caseData()?.[0]?.docTypename,
      "ctpId": this.caseData()?.[0]?.ctpId,
      "cptId": this.caseData()?.[0]?.cptId,
      "ctpShortName": this.caseData()?.[0]?.ctpShortName,
      "cptShortName": this.caseData()?.[0]?.cptShortName,
      "receiptTypeId": this.caseData()?.[0]?.receiptTypeId,
      "receiptTypeName": this.caseData()?.[0]?.receiptTypeName,
      "restrictionId": this.caseData()?.[0]?.restrictionId,
      "partiesByPrtIdIssuedBy": this.caseData()?.[0]?.partiesByPrtIdIssuedBy,
      "partiesByPrtIdReallyIssuedBy": this.caseData()?.[0]?.partiesByPrtIdReallyIssuedBy,
      "partyIdCharging": this.caseData()?.[0]?.partyIdCharging,
      "partiesByPrtIdIssuedByName": this.caseData()?.[0]?.partiesByPrtIdIssuedByName,
      "partiesByPrtIdReallyIssuedByName": this.caseData()?.[0]?.partiesByPrtIdReallyIssuedByName,
      "partyIdChargingName": this.caseData()?.[0]?.partyIdChargingName,
      "restrictionName": this.caseData()?.[0]?.restrictionName,
      "ccmId": this.caseData()?.[0]?.ccmId,
      "ccmDesc": this.caseData()?.[0]?.ccmDesc,
      "dateMailed": null,
      "dateReceived": this.caseData()?.[0]?.dateReceived,
      "numberOfCopies": this.caseData()?.[0]?.numberOfCopies,
      "validString": this.caseData()?.[0]?.validString,
      "oldCaseNumber": this.caseData()?.[0]?.oldCaseNumber,
      "suitNumber": this.caseData()?.[0]?.suitNumber,
      "comments": this.caseData()?.[0]?.comments,
      "transType": this.caseData()?.[0]?.transType,
      "documentsGridAddMessage": this.caseData()?.[0]?.documentsGridAddMessage,
      "uploadDocTypeId": this.caseData()?.[0]?.uploadDocTypeId,
      "uploadDocTypename": this.caseData()?.[0]?.uploadDocTypename,
      "uploadDocCasePhTypeId": this.caseData()?.[0]?.uploadDocCasePhTypeId,
      "uploadDateReceived": this.caseData()?.[0]?.uploadDateReceived,
      "NoBriefsFlag": this.caseData()?.[0]?.noBriefsFlag,
      "triggeredTaskId": this.caseData()?.[0]?.triggeredTaskId,
      "triggeredTaskDetails": this.caseData()?.[0]?.triggeredTaskDetails,
      "totalCaseValue": this.caseData()?.[0]?.totalCaseValue,
      "letterNumber": "",
      "casePhaseCasId": this.caseData()?.[0]?.casePhaseCasId,
      "casePhaseId": this.caseData()?.[0]?.casePhaseId,
      "appealCourtId": this.caseData()?.[0]?.appealCourtId,
      "appealCourtName": this.caseData()?.[0]?.appealCourtName,
      "counselFlag": this.caseData()?.[0]?.counselFlag,
      "entryCompleted": this.caseData()?.[0]?.entryCompleted,
      "valid": this.caseData()?.[0]?.valid
    }

    this.service.sentMail(reqBody).subscribe({
      next: (res: IResponse<TAny> | null) => {
        if (res?.data && res.data.length > 0) {
          //console.log(res.data)
        }
        this.dialogService.openDialog1({
          data: {
            title: "Information",
            message: res?.data,
            icon: 'info',
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
      },
    });
  }
  convertTimestampToDate(secondsOrMilliseconds: number): string {
    let timestamp = secondsOrMilliseconds;

    if (timestamp.toString().length === 10) {
      timestamp *= 1000;
    }

    const date = new Date(timestamp);

    return formatDate(date, 'dd-MMM-yyyy', 'en-US');
  }


  public downloadFile(document: TAny) {
    const data: IAttachmentDialogData = {
      path: 'documents/download.htm',
      queryParams: { fileRef: document.docURL == undefined ? document.alfrescoUrl : document.docURL }
    };

    this.dialog.open(AttachmentViewerComponent, {
      width: '90vw',
      maxWidth: '95vw',
      height: '90vh',
      panelClass: 'attachment-dialog',
      data, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
  }


  public searchHandler(caseNumber?: string, isfast: boolean = false): void {
    // 1) Reset state signals & properties
    this.caseData.set([]);
    this.partyDetails.set([]);
    this.attachmentsData.set([]);
    this.MotioncaseList.set([]);
    this.selectedData = [];
    this.selectedDoc = null;
    this.selectedparties = null;
    this.selectedRepPartiesData.set([]);
    this.selectedPartyrep = null;
    this.fileUrl = '';
    this.dateReceived = null;
    this.selectedFile = null;
    this.isRepEdit = false;
    this.counselPartiesData.set([]);
    this.listofPartiesData.set([]);
    this.selectedWitnessData.set([]);

    this.isDashboard = isfast;

    let reqBody: any;
    const currentTask = this.task();

    // 2) Build request payload based on whether a task exists
    if (currentTask) {
      const taskTypeName = currentTask.typeName?.trim().toUpperCase();

      if (taskTypeName === this.strings.CASE_ASSIGNMENT_TASK) {
        this.isDirectAssign = true;
        this.assignButtonName = this.strings.CASE_ASSIGNMENT_BUTTON;
      } else if (taskTypeName === this.strings.VALIDATE_DOCUMENTS_TASK) {
        this.isDirectAssign = true;
        this.assignButtonName = this.strings.VALIDATE_DOCUMENT_BUTTON;
      } else {
        this.isDirectAssign = false;
        this.assignButtonName = 'Add';
      }

      reqBody = {
        courtCaseNumber: currentTask.courtCaseNumber ?? '',
        docTypeId: '',
        casePhaseId: '',
        triggeredTaskId: currentTask.tasksId,
        triggeredTaskDetails: currentTask.taskDetails,
        docId: currentTask.docId
      };
    } else {
      this.isDirectAssign = false;
      this.assignButtonName = 'Add';

      const formCaseVal = this.searchFormGrp.get('caseNumber')?.value;
      const resolvedCaseNumber = caseNumber?.trim() || formCaseVal?.caseNumber || formCaseVal || '';

      reqBody = {
        courtCaseNumber: resolvedCaseNumber,
        docTypeId: this.selectedDocumentType?.docTypeId?.toString() ?? '',
      };
    }

    // 3) Validate and execute search
    const hasValidCaseNumber = !!caseNumber?.trim() || !!this.searchFormGrp.get('caseNumber')?.value;

    if (this.searchFormGrp.valid || hasValidCaseNumber || !!currentTask) {
      this.getCaseData(reqBody);
      this.formGrp.disable();
      this.clearQueryParams();
    } else {
      this.dialogService.openDialog1({
        data: {
          title: 'Information',
          message: 'Please select or Enter Case Number',
          icon: 'info',
        },
        disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    }
  }

  // FIX: Updated caseDisplayFn to handle string (initial value) vs Object (selected value)
  public caseDisplayFn(item: ICaseItem | string): string {
    if (!item) return '';
    if (typeof item === 'string') return item;
    return item.caseNumber || '';
  }

  public resetHandler() {
    this.searchFormGrp.reset();
    this.docTypeFilterCtrl.setValue('');
    this.selectedDocumentType = null;
    this.taskDetails.set(null)

    this.caseData.set([]);
    this.partyDetails.set([]);
    this.caseData.set([]);
    this.partyDetails.set([]);
    this.attachmentsData.set([]);
    this.MotioncaseList.set([]);
    this.selectedData = [];
    this.selectedDoc = null;
    this.selectedparties = null;
    this.selectedRepPartiesData.set([]);
    this.selectedPartyrep = null;
    this.fileUrl = "";
    this.dateReceived = null;
    this.selectedFile = null;
    this.isRepEdit = false
    this.counselPartiesData.set([]);
    this.caseList.set([])
    this.isAddSearchHandlerDD = false;
    this.listofPartiesData.set([])
    this.selectedDocumentType = null; this.selectedWitnessData.set([]);
    this.clearQueryParams();
  }


  public openAttachmentDialog(document: IHPAttachment) {
    const data: IAttachmentDialogData = {
      path: 'documents/download.htm',
      queryParams: { fileRef: document.alfrescoUrl }
    };

    this.dialog.open(AttachmentViewerComponent, {
      panelClass: 'dialog-pdf-viewer',
      data, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
  }
  public getCaseData(reqBody: IDRCaseSearchRequestBody) {
    this.loading = true;
    this.caseData.set([]);
    this.attachmentsData.set([]);
    this.isAddSearchHandlerDD = false;

    this.service.searchCaseDetailsIDR(reqBody).subscribe({
      next: (res: IDRCaseDocument[] | null) => {
        if (res && res.length > 0) {
          const sortedRes = [...res].sort((a, b) => {
            if (a.casePhaseId === 1) return -1;
            if (b.casePhaseId === 1) return 1;
            return (a.casePhaseId ?? 0) - (b.casePhaseId ?? 0);
          });

          // 2. Assign sorted response to state / signals
          this.caseData.set(sortedRes);
          this.myNewRes = sortedRes;
          this.isAddSearchHandlerDD = true;
          this.partyRoles = this.partyRoles = this.caseData()[0].caseCategory === 'FI' ? this.caseData()[0].ctpShortName === 'CR' ? ["Prosecutor", "Defendant"] : ["Plaintiff/Claimant", "Defendant"] : ["Appellant", "Respondent"]
          this.task.set(null);

        } else {
          this.dialogService.openDialog1({
            data: {
              title: "Information",
              message: 'No Privilege to access the data (or) No Data Exists',
              icon: 'info',
            }, disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });
        }
        this.loading = false
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
        this.isAddSearchHandlerDD = false;
        this.loading = false;
      },
    });
  }

  onCloseTask(attachment: any): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: 'Do you want to Close Task?',
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        //console.log('Close task cancelled.');
        return;
      }

      const currentCase = this.caseData()?.[0];
      if (!currentCase) {
        console.error('No case data found to extract task details.');
        return;
      }

      const reqdata: TAny = {
        triggeredTaskDetailsStr: currentCase.triggeredTaskDetails,
        triggeredTaskId: currentCase.triggeredTaskId,
        triggeredDocName: attachment.docName,
      };

      this.service.onCloseTask(reqdata).subscribe({
        next: (res: IResponse<TAny> | null) => {
          if (res?.success) {
            this.dialogService.openDialog1({
              data: {
                title: 'Success',
                message: res.message,
                icon: 'check_small',
              },
              disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });

            // 1. Reactive Signal update: Immutably update the signal array to guarantee UI re-renders immediately
            this.attachmentsData.update((list) =>
              list.map((item) =>
                item === attachment || item.docName === attachment.docName
                  ? { ...item, showClosetask: false }
                  : item
              )
            );

            this.selectedDoc = null;
            this.assignTaskService.getTasks();

            // 2. Refresh documents only on success (guard against empty selectedData)

          } else {
            this.dialogService.openDialog1({
              data: {
                title: 'Info',
                message: res?.message ?? 'Action could not be completed.',
                icon: 'info',
              },
              disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
          }
        },
        error: (err) => {
          console.error('Error closing task:', err);
          this.dialogService.openDialog1({
            data: {
              title: 'Error',
              message: 'Failed to close task. Please try again.',
              icon: 'error',
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });
        },
      });
    });
  }

  onDateChange(event: any): void {
    this.dateReceived = event.value
    this.formattedDate = null;

    const date = event.value;
    if (date) {
      const tempformattedDate = this.datePipe.transform(date, 'dd-MMM-yyyy');
      this.formattedDate = tempformattedDate;
    } else {
      console.error('Invalid date value:', date);
    }
  }

  public onFileUpload(): void {
    this.docFormGrp.markAllAsTouched();

    if (!this.selectedFile || !this.formattedDate) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please select a file and a date.',
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
      return;
    }

    const file: File = this.selectedFile;

    if (!(file instanceof File)) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Invalid file. Please select a valid file.',
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('documentsData', '');

    const queryParams = {
      docId: this.selectedData[0].docId,
      caseId: this.selectedData[0].casePhaseCasId,
      casePhaseId: this.selectedData[0].casePhaseId,
      dateReceived: this.formattedDate,
      docTypeID: this.selectedData[0].docTypeId,
      caseNumber: this.selectedData[0].courtCaseNumber,
    };

    this.isUploading = true;

    this.service.uploadFile(formData, queryParams).subscribe({
      next: (res) => {
        this.dialogService.openDialog1({
          data: {
            title: "Information",
            message: res.success ? res.success : res.failure,
            icon: 'info',
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });

        this.docFormGrp.reset({
          docUploadDateReceived: this.today,
        });

        const item = this.caseList().find(
          (item) => item.caseNumber === this.selectedData[0].courtCaseNumber
        );
        this.searchFormGrp.reset({
          caseNumber: item ?? '',
        });
        this.clearFileUrl();
        this.selectedFile = null;
        this.dateReceived = null;
        this.formattedDate = "";
        this.isUploading = false;
        this.getDocData(this.selectedData[0].docId, this.selectedData[0].casePhaseCasId, this.selectedData[0].courtCaseNumber)
      },
      error: (err) => {
        console.error('File upload failed:', err);
        this.dialogService.openDialog1({
          data: {
            title: "Information",
            message: 'File upload failed. Please try again.',
            icon: 'info',
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
        this.isUploading = false;

      },
    });

    this.getDocData(this.selectedData[0].docId, this.selectedData[0].casePhaseCasId, this.selectedData[0].courtCaseNumber)
  }

  private searchbyCaseNoChange() {
    this.searchFormGrp.controls['caseNumber'].valueChanges
      .pipe(
        takeUntilDestroyed(),
        filter(val => {
          if (typeof val === 'string' && val.trim().length > 3) {
            this.caseListLoader.set(true);
            return true;
          }
          this.caseListLoader.set(false);
          return false;
        }),
        debounceTime(500),
        switchMap((searchVal: string) => this.searchCases(searchVal))
      )
      .subscribe({
        next: (res: IResponse<ICaseItem[]>) => {
          this.caseList.set(res.data);
          this.caseListLoader.set(false);
        },
        error: () => {
          this.caseListLoader.set(false);
        }
      });
  }

  private searchCases(val: string) {
    const body: ICaseSearchRequestBody = {
      caseNumber: val,
      dateOfFiling: 'null'
    };
    const params: ISearchRequestParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'id',
      direction: 'ASC'
    }
    return this.service.searchCaseNumber(body, params);
  }

  editdocument() {
    this.loading = true;
    const reqbody: TAny = {
      "courtCaseNumber": this.caseData()?.[0]?.courtCaseNumber,
      "docTypeId": this.selectedData[0].docTypeId,
    }
    this.service.searchCaseDetailsIDR(reqbody).subscribe({
      next: (res: IDRCaseDocument[] | null) => {
        //console.log(res)
        if (res && res.length > 0) {
          this.openModalEdit(res)
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
        this.loading = false;
      },
    });
  }


  openModal() {
    const dialogRef = this.dialog.open(DocumentDetailsComponent, {
      width: '70vw',
      maxWidth: 'none',
      height: '90vh',
      panelClass: 'custom-full-screen-dialog',
      disableClose: true,
      data: {
        flg: this.isAddSearchHandlerDD,
        resData: this.myNewRes,
        isBacklogCase: false,
        onRefreshTasks: () => this.dashboard.refreshSidebarTasks()
      },
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //console.log('Modal closed with success:', result);
        this.searchHandler(result);
      }
    });
  }

  openBacklogModal() {
    const dialogRef = this.dialog.open(DocumentDetailsComponent, {
      width: '70vw',
      maxWidth: 'none',
      height: '90vh',
      panelClass: 'custom-full-screen-dialog',
      disableClose: true,
      data: {
        flg: false,
        resData: [],
        isBacklogCase: true,
        onRefreshTasks: () => this.dashboard.refreshSidebarTasks()
      },
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //console.log('Backlog Modal closed with success:', result);
        this.searchHandler(result);
      }
    });
  }
  openModalEdit(data: IDRCaseDocument[]): void {
    if (!data || data.length === 0) {
      console.warn('No data provided to openModalEdit.');
      return;
    }
    const appealDetails = this.myNewRes[0]['appealRecordDto'];

    const dialogRef = this.dialog.open(DocumentDetailEditComponent, {
      width: '70vw',
      maxWidth: 'none',
      height: '90vh',
      panelClass: 'custom-full-screen-dialog',
      disableClose: true,
      data: { data: data, loginData: this.courtData, AppealDetails: appealDetails },
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogService.openDialog1({
          data: {
            title: "Information",
            message: result.data.validString,
            icon: 'info',
            onRefreshTasks: () => this.dashboard.refreshSidebarTasks()
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });


        this.searchHandler(result.data.courtCaseNumber)

      } else {
        //console.log('Edit dialog was closed without changes.');
      }
    });
  }
  handleCommentsSubmitted(commentsDialog: HTMLDialogElement): void {
    // Close the comments dialog box immediately
    commentsDialog.close();

    // Proceed to Step 2: Ask for the final action confirmation
    this.assignDirectCase();
  }

  assignDirectCase(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: 'Do you want to Save?'
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
      if (result) {
        const index = this.myNewRes && this.myNewRes.length > 0 ? this.myNewRes.length - 1 : 0;

        // Pass the index downstream into the API processing chain
        this.getDocumentType(index);
      } else {
        //console.log('Save Cancelled! Preserving comments in case they want to retry.');
      }
    });
  }

  getDocumentType(docIndex: number): void {
    const queryParams: any = {
      caseId: this.myNewRes?.[docIndex]?.casePhaseCasId,
      parentDocId: this.myNewRes?.[docIndex]?.docTypeId,
      appealTypeId: this.myNewRes?.[docIndex]?.ctpId,
      caseNumber: this.myNewRes?.[docIndex]?.courtCaseNumber
    };

    this.loading = true;

    this.documentDetailsService.getDocumentTypesAdd(queryParams).subscribe({
      next: (response) => {
        let caseAssignmentDoc: any = null;
        const documentList = response?.success || [];

        const normalize = (name?: string): string =>
          name?.trim().toLowerCase() ?? '';

        if (this.assignButtonName === this.strings.CASE_ASSIGNMENT_BUTTON) {

          const allowedDocTypes: readonly string[] = [
            APP_STRING.DOC_TYPE_CASE_ASSIGNMENT,
            APP_STRING.DOC_TYPE_CASE_READY_FOR_ASSIGNMENT,
            APP_STRING.DOC_TYPE_READY_FOR_ASSIGNMENT
          ].map(normalize);

          caseAssignmentDoc = documentList.find((item: any) =>
            allowedDocTypes.includes(normalize(item?.docTypeName))
          );

        } else if (
          this.assignButtonName === this.strings.VALIDATE_DOCUMENT_BUTTON
        ) {

          const allowedDocTypes: readonly string[] = [
            APP_STRING.DOC_TYPE_DOCUMENTS_VALIDATED,
            APP_STRING.DOC_TYPE_DOCUMENTS_VALIDATED_RECORD
          ].map(normalize);

          caseAssignmentDoc = documentList.find((item: any) =>
            allowedDocTypes.includes(normalize(item?.docTypeName))
          );
        }

        if (caseAssignmentDoc) {
          const doc = caseAssignmentDoc;

          this.documentTypes = {
            docmentTypeId: doc.docTypeId,
            docmentTypeName: doc.docTypeName ?? '',
            cptId: doc.cptId ?? 0,
            transType: doc.transType ?? '',
            auditMessage: doc.auditMessage ?? ''
          };

          if (doc.docTypeId) {
            this.fetchCaseStages(doc.docTypeId, docIndex);
          } else {
            this.loading = false;
          }

        } else {
          this.isDirectAssign = false;
          this.loading = false;
          this.documentTypes = null;
          this.resetCommentBuffer();
          return;
        }
      },

      error: (err) => {
        console.error('Error fetching document types:', err);
        this.loading = false;
        this.resetCommentBuffer();
      }
    });
  }
  fetchCaseStages(docTypeId: number, docIndex: number): void {
    this.documentDetailsService.getCaseStages(docTypeId).subscribe({
      next: (response) => {
        this.caseStages = response.data?.[0] || null;
        const reqBody = this.prepareRequestPayload(docIndex);
        this.saveEdit(reqBody);
      },
      error: (err) => {
        console.error('Error fetching case stage:', err);
        this.loading = false;
        this.resetCommentBuffer();
      },
    });
  }

  saveEdit(reqBody: any): void {
    //console.log('test', reqBody);

    this.documentDetailsService.upsertDocument(reqBody).pipe(
      catchError((error) => {
        console.error('Error updating document party data:', error);
        this.loading = false;
        return EMPTY;
      }),
      finalize(() => {
        this.loading = false;
        this.dashboard.refreshSidebarTasks();
        this.task.set(null);
        this.isDirectAssign = false;

        // Wipe out comment data now that saving completed
        this.resetCommentBuffer();
      })
    ).subscribe({
      next: (response) => {
        if (response.data.validString) {
          this.dialogService.openDialog1({
            data: { title: "Success", message: response.data.validString, icon: 'check_small' },
            disableClose: true, hasBackdrop: true, backdropClass: 'dialog-backdrop',
          });
        } else {
          this.dialogService.openDialog1({
            data: { title: "Information", message: response.data.validString, icon: 'info' },
            disableClose: true, hasBackdrop: true, backdropClass: 'dialog-backdrop',
          });
        }
        if (response?.data?.courtCaseNumber) {
          this.searchHandler(response.data.courtCaseNumber);
        }
      }
    });
  }

  private resetCommentBuffer(): void {
    this.userComments = '';
  }
  prepareRequestPayload(index: number): any {
    const currentDate = new Date();
    const selectedFiledOnDate = this.datePipe.transform(currentDate, 'dd-MMM-yyyy');
    const targetRes = this.myNewRes?.[index] || {};

    return {
      // ... structural mapping properties remain exactly identical ...

      // Successfully map the captured string variable into the payload
      comments: this.userComments || targetRes.comments || '',

      courtUnitName: targetRes.courtUnitName,
      courtUnitId: targetRes.courtUnitId,
      appealCourtName: targetRes.appealCourtName || "",
      appealCourtId: targetRes.appealCourtId || '',
      ctpShortName: targetRes.ctpShortName || '',
      ctpId: targetRes.ctpId || '',
      docTypename: this.documentTypes?.docmentTypeName,
      docTypeId: this.documentTypes?.docmentTypeId,
      cptShortName: this.caseStages?.phaseName,
      cptId: this.caseStages?.documentTypeCasePhaseTypeId,
      courtCaseNumber: targetRes.courtCaseNumber,
      casePhaseId: targetRes.casePhaseId,
      docId: targetRes.docId,
      casePhaseCasId: targetRes.casePhaseCasId,
      partiesByPrtIdReallyIssuedBy: targetRes.partiesByPrtIdReallyIssuedBy,
      partiesByPrtIdReallyIssuedByName: targetRes.partiesByPrtIdReallyIssuedByName,
      filedByPartyIdPartyType: targetRes.filedByPartyIdPartyType ?? '',
      partiesByPrtIdIssuedBy: targetRes.partiesByPrtIdIssuedBy,
      partiesByPrtIdIssuedByName: targetRes.partiesByPrtIdIssuedByName,
      appellentPartyIdPartyType: targetRes.appellentPartyIdPartyType ?? '',
      appGroupGovtFlag: targetRes.appGroupGovtFlag ?? '',
      partyIdCharging: targetRes.partyIdCharging,
      partyIdChargingName: targetRes.partyIdChargingName,
      respondentFieldIdPartyType: targetRes.respondentFieldIdPartyType ?? '',
      respGroupGovtFlag: targetRes.respGroupGovtFlag ?? '',
      isTrackingNumber: '',
      restrictionName: targetRes.restrictionName,
      restrictionId: 2,
      receiptTypeName: 'Hand',
      receiptTypeId: 1,
      numberOfCopies: targetRes.numberOfCopies ?? '1',
      dateReceived: selectedFiledOnDate,
      dateMailed: selectedFiledOnDate || "",
      oldCaseNumber: targetRes.oldCaseNumber,
      suitNumber: targetRes.suitNumber,
      triggeredTaskId: targetRes.triggeredTaskId || '',
      triggeredTaskDetails: '',
      cutId: '',
      hearingCourtUnitName: targetRes.hearingCourtUnitName || "",
      hearingCourtUnitId: targetRes.hearingCourtUnitId || '',
      transType: 'I',
      documentsGridAddMessage: 'ADD',
      uploadDateReceived: '',
      courtType: this.isSupremeCourtFlg ? 'SC' : (this.isCOAFlg ? 'CA' : 'HC'),
      caseCategory: targetRes.caseCategory,
      courtUnitShortName: targetRes.courtUnitShortName,
      backlogCaseFlag: false,
      backlogCaseNumber: ''
    };
  }
  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date ? date >= today : false;
  };

  getconfirmation(buttontype: string): void {
    const invalidPartyDetails = this.partyDetails().some(
      (party) => !party.partyRoleName || party.partyRoleName.trim() === ''
    );

    const invalidCounselPartiesData = this.counselPartiesData().some(
      (representation) =>
        !representation.beginDate ||
        representation.beginDate === null ||
        !representation.endDate ||
        representation.endDate === null
    ); if (invalidPartyDetails) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "Please select party Role",
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
      return;
    } else if (invalidCounselPartiesData) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "please select Begin and End Date",
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });

      return;
    } else {

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirm Action',
          message: "Do you want to Save",
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          if (buttontype === 'Save') {
            this.preparePayload();
          }
        } else {
          //console.log('Cancelled!');
        }
      });
    }

  }
  preparePayload() {

    const docpartypayload: DocPartyData[] = this.partyDetails().map((party) => ({
      partyId: party.partyId,
      partyName: party.partyName,
      partyRoleId: party.partyRoleId,
      partyRoleName: party.partyRoleName,
      timeCreated: party.timeCreated || '',
      A$T: '',
      termination: party.termination || '',
      transType: party.transType || '',
      representationData: party.partyId === this.selectedparties?.partyId
        ? (this.isRepEdit
          ? this.counselPartiesData().map((representation) => ({
            partyId: representation.partyId,
            partyName: representation.partyFullName,
            partyFullName: '',
            groupPartyId: representation.groupPartyId || '',
            beginDate: representation.beginDate
              ? new Date(representation.beginDate).toISOString().slice(0, 19)
              : '',
            endDate: representation.endDate
              ? new Date(representation.endDate).toISOString().slice(0, 19)
              : '',
            transType: "U",
          }))
          : this.counselPartiesData()
            .filter((representation) =>
              this.selectedRepPartiesData().some(
                (selectedRep) => selectedRep.partiesId === representation.partyId
              )
            )
            .map((representation) => ({
              partyId: representation.partyId,
              partyName: representation.partyFullName,
              partyFullName: '',
              groupPartyId: representation.groupPartyId || '',
              beginDate: representation.beginDate
                ? new Date(representation.beginDate).toISOString().slice(0, 19)
                : '',
              endDate: representation.endDate
                ? new Date(representation.endDate).toISOString().slice(0, 19)
                : '',
              transType: "I",
            })))
        : [],
      groupPartiesData: [],
      witnessData: party.partyId === this.selectedparties?.partyId
        ? this.witnessData()
          .filter((witness) =>
            this.selectedWitnessData().some((selectedWitness) => selectedWitness.partiesId === witness.witnessId)
          )
          .map((witness) => ({
            witnessId: witness.witnessId,
            witnessName: witness.witnessName,
            witnessAddr: witness.witnessAddr,
            witnessContact: witness.witnessContact,
            transType: "I",
            auditMessage: "",
          }))
        : [],

    }));

    const payloadsave: CaseDataPayload = {
      id: 1,
      courtCaseNumber: this.caseData()[0]?.courtCaseNumber || '',
      caseCategory: this.caseData()[0]?.caseCategory || '',
      courtUnitShortName: this.caseData()[0]?.courtUnitShortName || '',
      cutId: 0,
      docId: this.caseData()[0]?.docId || '',
      courtUnitId: this.caseData()[0]?.courtUnitId || 0,
      courtUnitName: this.caseData()[0]?.courtUnitName || '',
      hearingCourtUnitId: this.caseData()[0]?.hearingCourtUnitId || 0,
      hearingCourtUnitName: this.caseData()[0]?.hearingCourtUnitName || '',
      docTypeId: this.caseData()[0]?.docTypeId || 0,
      docTypename: this.caseData()[0]?.docTypename || '',
      ctpId: this.caseData()[0]?.ctpId || 0,
      cptId: this.caseData()[0]?.cptId || 0,
      ctpShortName: this.caseData()[0]?.ctpShortName || '',
      cptShortName: this.caseData()[0]?.cptShortName || '',
      receiptTypeId: this.caseData()[0]?.receiptTypeId || 0,
      receiptTypeName: this.caseData()[0]?.receiptTypeName || '',
      restrictionId: this.caseData()[0]?.restrictionId || 0,
      partiesByPrtIdIssuedBy: this.caseData()[0]?.partiesByPrtIdIssuedBy || '',
      partiesByPrtIdReallyIssuedBy: this.caseData()[0]?.partiesByPrtIdReallyIssuedBy || '',
      partyIdCharging: this.caseData()[0]?.partyIdCharging || '',
      partiesByPrtIdIssuedByName: this.caseData()[0]?.partiesByPrtIdIssuedByName || '',
      partiesByPrtIdReallyIssuedByName: this.caseData()[0]?.partiesByPrtIdReallyIssuedByName || '',
      partyIdChargingName: this.caseData()[0]?.partyIdChargingName || '',
      restrictionName: this.caseData()[0]?.restrictionName || '',
      ccmId: this.caseData()[0]?.ccmId?.toString() || '',
      ccmDesc: this.caseData()[0]?.ccmDesc?.toString() || '',
      dateMailed: this.caseData()[0]?.dateMailed?.toString() || '',
      dateReceived: this.caseData()[0]?.dateReceived?.toString() || '',
      numberOfCopies: this.caseData()[0]?.numberOfCopies || 0,
      validString: this.caseData()[0]?.validString?.toString() || '',
      oldCaseNumber: this.caseData()[0]?.oldCaseNumber || '',
      suitNumber: this.caseData()[0]?.suitNumber || '',
      comments: this.caseData()[0]?.comments || '',
      transType: "I",
      documentsGridAddMessage: this.caseData()[0]?.documentsGridAddMessage?.toString() || '',
      uploadDocTypeId: this.caseData()[0]?.uploadDocTypeId || 0,
      uploadDocTypename: this.caseData()[0]?.uploadDocTypename?.toString() || '',
      uploadDocCasePhTypeId: this.caseData()[0]?.uploadDocCasePhTypeId?.toString() || '',
      uploadDateReceived: this.caseData()[0]?.uploadDateReceived?.toString() || '',
      noBriefsFlag: this.caseData()[0]?.noBriefsFlag || false,
      triggeredTaskId: this.caseData()[0]?.triggeredTaskId?.toString() || '',
      triggeredTaskDetails: this.caseData()[0]?.triggeredTaskDetails?.toString() || '',
      totalCaseValue: this.caseData()[0]?.totalCaseValue || 0,
      letterNumber: this.caseData()[0]?.letterNumber?.toString() || '',
      casePhaseCasId: this.caseData()[0]?.casePhaseCasId || 0,
      casePhaseId: this.caseData()[0]?.casePhaseId || 0,
      appealCourtId: this.caseData()[0]?.appealCourtId || 0,
      appealCourtName: this.caseData()[0]?.appealCourtName?.toString() || '',
      counselFlag: this.caseData()[0]?.counselFlag || false,
      entryCompleted: false,
      valid: false,
      docPartiesData: docpartypayload,
      NoBriefsFlag: false,
    };


    //console.log(payloadsave);
    this.saveModification([payloadsave]);
  }

  formatDateToISO(date: Date | string): string {
    return this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss') || '';
  }
  public saveModification(reqBody: [CaseDataPayload]) {
    this.service.saveModification(reqBody).subscribe({
      next: (res: IResponse<TAny> | null) => {
        if (res?.data && res.data.length > 0) {
          //console.log(res.data)
          if (res.data.validString.toLowerCase().includes("saved successfully")) {
            this.dialogService.openDialog1({
              data: {
                title: "Success",
                message: res.data.validString,
                icon: 'check_small',
              }, disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
          } else {
            this.dialogService.openDialog1({
              data: {
                title: "Information",
                message: res.data.validString,
                icon: 'info',
              }, disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
          }
        }
        this.searchHandler(reqBody[0].courtCaseNumber)
      },
      error: (err) => {

        console.error('Error fetching case data:', err);
      },
    });
  }

  // THIS METHOD WAS MISSING AND IS NEEDED BY THE TEMPLATE
  onPrint(): void {
    if (this.caseData().length !== 0) {
      const reqData: any = {
        id: 1,
        courtCaseNumber: this.caseData()[0].courtCaseNumber ?? '',
        caseCategory: this.caseData()[0].caseCategory ?? '',
        courtUnitShortName: this.caseData()[0].courtUnitShortName ?? '',
        cutId: 0,
        docId: this.caseData()[0].docId ?? '',
        courtUnitId: this.caseData()[0].courtUnitId ?? '',
        courtUnitName: this.caseData()[0].courtUnitName ?? '',
        hearingCourtUnitId: this.caseData()[0].hearingCourtUnitId ?? '',
        hearingCourtUnitName: this.caseData()[0].hearingCourtUnitName ?? '',
        docTypeId: this.caseData()[0].docTypeId ?? '',
        docTypename: this.caseData()[0].docTypename ?? '',
        ctpId: this.caseData()[0].ctpId ?? '',
        cptId: this.caseData()[0].cptId ?? '',
        ctpShortName: this.caseData()[0].ctpShortName ?? '',
        cptShortName: this.caseData()[0].cptShortName ?? '',
        receiptTypeId: this.caseData()[0].receiptTypeId ?? '',
        receiptTypeName: this.caseData()[0].receiptTypeName ?? '',
        restrictionId: this.caseData()[0].restrictionId ?? '',
        partiesByPrtIdIssuedBy: this.caseData()[0].partiesByPrtIdIssuedBy ?? '',
        partiesByPrtIdReallyIssuedBy: this.caseData()[0].partiesByPrtIdReallyIssuedBy ?? '',
        partyIdCharging: this.caseData()[0].partyIdCharging ?? '',
        partiesByPrtIdIssuedByName: this.caseData()[0].partiesByPrtIdIssuedByName ?? '',
        partiesByPrtIdReallyIssuedByName: this.caseData()[0].partiesByPrtIdReallyIssuedByName ?? '',
        partyIdChargingName: this.caseData()[0].partyIdChargingName ?? '',
        restrictionName: this.caseData()[0].restrictionName ?? '',
        ccmId: this.caseData()[0].ccmId ?? '',
        ccmDesc: this.caseData()[0].ccmDesc ?? '',
        dateMailed: this.caseData()[0].dateMailed ?? '',
        dateReceived: this.caseData()[0].dateReceived ?? '',
        numberOfCopies: this.caseData()[0].numberOfCopies ?? '',
        validString: this.caseData()[0].validString ?? '',
        oldCaseNumber: this.caseData()[0].oldCaseNumber ?? '',
        suitNumber: this.caseData()[0].suitNumber ?? '',
        comments: this.caseData()[0].comments ?? '',
        transType: this.caseData()[0].transType ?? '',
        documentsGridAddMessage: this.caseData()[0].documentsGridAddMessage ?? '',
        uploadDocTypeId: this.caseData()[0].uploadDocTypeId ?? '',
        uploadDocTypename: this.caseData()[0].uploadDocTypename ?? '',
        uploadDocCasePhTypeId: this.caseData()[0].uploadDocCasePhTypeId ?? '',
        uploadDateReceived: this.caseData()[0].uploadDateReceived ?? '',
        NoBriefsFlag: false,
        triggeredTaskId: this.caseData()[0].triggeredTaskId ?? '',
        triggeredTaskDetails: this.caseData()[0].triggeredTaskDetails ?? '',
        totalCaseValue: this.caseData()[0].totalCaseValue ?? '',
        letterNumber: this.caseData()[0].letterNumber ?? '',
        casePhaseCasId: this.caseData()[0].casePhaseCasId ?? '',
        casePhaseId: this.caseData()[0].casePhaseId ?? '',
        appealCourtId: this.caseData()[0].appealCourtId ?? '',
        appealCourtName: this.caseData()[0].appealCourtName ?? '',
        counselFlag: this.caseData()[0].counselFlag,
        entryCompleted: this.caseData()[0].entryCompleted,
        valid: this.caseData()[0].valid ?? '',
      }
      //console.log(`ReqData :: ${reqData}`);
      this.service.getPrintReceipt(reqData).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
        },
        error: (err) => {
          console.error('Error while printing:', err);
          this.dialogService.openDialog1({
            data: {
              title: "Information",
              message: 'Failed to generate print file.',
              icon: 'info',
            }, disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });

        },
      });

    }
  }

  // THIS METHOD WAS MISSING AND IS NEEDED BY THE TEMPLATE
  getColumnStyle(column: string): any {
    const widths: { [key: string]: string } = {
      select: '4%',
      plaintiff: '15%',
      defendant: '15%',
      caseType: '7%',
      docType: '15%',
      caseStage: '10%',
      caseNumber: '17%',
      receivedDate: '9%',
      docId: '8%'

    };

    return {
      width: widths[column] || 'auto',
      'white-space': 'normal',
      'word-break': 'break-word',
      padding: '2px 2px',
      'text-align': column === 'select' ? 'center' : 'left'
    };
  }

  // THIS METHOD WAS MISSING AND IS NEEDED BY THE TEMPLATE
  modifyPartyRep() {
    if (this.selectedPartyrep === null) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: "Please select parties",
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    } else {
      this.selectedRepPartiesData.set(this.selectedPartyrep);
      this.isRepEdit = true;
    }

  }

  // THIS METHOD WAS MISSING AND IS NEEDED BY THE TEMPLATE
  cancelPartyRep() {
    this.selectedRepPartiesData.set([]);
    this.isRepEdit = false;

  }

}


function createDefaultAdditionalSupremeCourtCaseData(): AdditionalSupremeCourtCaseData {
  return {
    filingCourt: '',
    caseType: '',
    suitNo: '',
    lowerCourtCaseNo: '',
    comment: '',
    courtOfAppeal: '',
    appealDivision: '',
    appealCaseNo: '',
    appealJudgmentDate: '',
    noticeFiledDate: '',
    transmissionDate: '',
    appealServiceDate: '',
    supplementaryFiled: false,
    supplementaryFiledDate: '',
    trialCourt: '',
    trialCourtDivision: '',
    trialJudge: '',
    trialJudgmentDate: '',
    appellantServiceDate: '',
    suitReferenceKey: '',
    casereqId: '',
    caseId: '',
    createdByApp: '',
    createdAt: '',
    justiceIds: []
  };

}